<template>
  <textarea rows="1" id="text" class="commentInput" />
</template>

<script>
export default {

}
</script>

<style>
.commentInput{
    min-width: 150px;
    width: 250px;
    max-width: 250px;
    margin: 5px;
    padding: 10px;
    border-radius: 10px;
    border: none;
}
</style>